import React, { useState, useEffect } from 'react';
import { useLang } from '../context/LanguageContext';
import useScrollReveal from '../hooks/useScrollReveal';
import './About.css';

export default function About() {
  const { t, lang } = useLang();
  const headerRef = useScrollReveal();
  const textRef = useScrollReveal();
  const [paras, setParas] = useState({ cs: [], en: [] });

  useEffect(() => {
    fetch('/api/verunka/about')
      .then(r => r.json())
      .then(data => setParas({ cs: data.cs || [], en: data.en || [] }))
      .catch(() => {});
  }, []);

  const body = paras[lang] || [];

  return (
    <section id="about" className="about">
      <div className="about__inner">
        <div ref={headerRef} className="section-label reveal">{t.about.title}</div>
        <div className="about__content">
          <div ref={textRef} className="about__text reveal">
            {body.map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
          <div className="about__divider" />
        </div>
      </div>
    </section>
  );
}
